import { useTranslate } from '@refinedev/core';
import { Tag } from 'antd';

// ─── UserRoleTag ─────────────────────────────────────────────────────────────

const USER_ROLE_COLOR: Record<string, string> = {
  superadmin: 'red',
  admin: 'orange',
  editor: 'blue',
  user: 'green',
};

export const UserRoleTag = ({ role }: { role: string }) => {
  const t = useTranslate();
  return (
    <Tag color={USER_ROLE_COLOR[role] ?? 'default'}>
      {t(`iam.users.roles.${role}`)}
    </Tag>
  );
};

// ─── ProfileRoleTag ───────────────────────────────────────────────────────────

const PROFILE_ROLE_COLOR: Record<string, string> = {
  owner: 'gold',
  admin: 'blue',
  member: 'default',
};

export const ProfileRoleTag = ({ role }: { role: string }) => (
  <Tag color={PROFILE_ROLE_COLOR[role] ?? 'default'}>{role}</Tag>
);

// ─── ConsentKindTag ───────────────────────────────────────────────────────────

const CONSENT_KIND_COLOR: Record<string, string> = {
  terms: 'blue',
  privacy_policy: 'green',
  newsletter: 'purple',
  partner_communication: 'cyan',
};

export const ConsentKindTag = ({ kind }: { kind: string }) => (
  <Tag color={CONSENT_KIND_COLOR[kind] ?? 'default'}>{kind}</Tag>
);

// ─── OAuthProviderTag ─────────────────────────────────────────────────────────

const OAUTH_PROVIDER_COLOR: Record<string, string> = {
  google: 'blue',
  apple: 'default',
};

const OAUTH_PROVIDER_ICON: Record<string, string> = {
  google: '🔵',
  apple: '🍎',
};

export const OAuthProviderTag = ({ provider }: { provider: string }) => {
  const t = useTranslate();
  const icon = OAUTH_PROVIDER_ICON[provider];
  return (
    <Tag
      color={OAUTH_PROVIDER_COLOR[provider] ?? 'default'}
      icon={icon ? <span>{icon}</span> : undefined}
    >
      {t(`iam.oauth_accounts.providers.${provider}`, provider)}
    </Tag>
  );
};
